export const colors = {
  primary: "#0E4D64",
  secondary: "#16A34A",
  accent: "#F97316",
  success: "#16A34A",
  warning: "#F97316",
  danger: "#DC2626",
  light: "#F3F7FA",
  surface: "#FFFFFF",
  surfaceSoft: "#F8FAFC",
  background: "#F3F7FA",
  border: "#D7E2EA",
  muted: "#5B6B76",
  text: "#10222D",
  textLight: "#FFFFFF",
  inputBackground: "#F8FAFC",
  focus: "#0E4D64",
  brandGradient: "linear-gradient(135deg, #0E4D64 0%, #16A34A 100%)",

  statusSuccessSurface: "#ECFDF3",
  statusSuccessBorder: "#86EFAC",
  statusSuccessText: "#166534",

  statusDangerSurface: "#FEF2F2",
  statusDangerBorder: "#FCA5A5",
  statusDangerText: "#991B1B",

  statusWarningSurface: "#FFFBEB",
  statusWarningBorder: "#FCD34D",
  statusWarningText: "#92400E",

  statusInfoSurface: "#EFF6FF",
  statusInfoBorder: "#BFDBFE",
  statusInfoText: "#1D4ED8"
};
